import React, { useEffect, useState, useRef } from 'react';
import { MenuItem, MenuList, ClickAwayListener, Grow, Paper, Popper } from '@mui/material';
import './UserProfileMenu.scss';

/**
 * @param {{
*  initials?: string;
*  fullName?: string;
*  version?: string;
*  environement?: string;
*  labels?: {
*     sectionTitleAbout: string;
*     aboutVersion: string;
*     aboutEnvironment: string;
*  };
* }} props
*/
const UserProfileMenu = ({
    initials = "",
    fullName = "",
    version = "",
    environement = "",
    labels = {
        sectionTitleAbout: "About",
        aboutVersion: "Version",
        aboutEnvironment: "Environment"
    }
}) => {
    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null);

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpen(false);
    };

    // return focus to the button when we transitioned from !open -> open
    const prevOpen = useRef(open);
    useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }

        prevOpen.current = open;
    }, [open]);

    return (
        <div className={"user-profile-menu-root"}>
            <span className={"user-profile-menu-avatar"}
                onClick={handleToggle}
                ref={anchorRef}>
                {initials}
            </span>
            <Popper
                className={"user-profile-menu-popper"}
                open={open}
                anchorEl={anchorRef.current}
                transition
            >
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{ transform: `translate(-8px, 2px)` }}
                    >
                        <Paper className={"menu-profile-menu-paper"}>
                            <ClickAwayListener onClickAway={handleClose}>
                                <MenuList className={"user-profile-menu-list"} autoFocusItem={open} id="menu-list-grow">
                                    <MenuItem className={"user-profile-menu-user-info"}>
                                        <span
                                            className={"user-profile-menu-avatar"}
                                        >
                                            {initials}
                                        </span>
                                        {fullName}
                                    </MenuItem>
                                    <hr className={"menu-profile-menu-dividers"} />
                                    <MenuItem className={"user-profile-menu-section-title"}>{labels?.sectionTitleAbout ? labels.sectionTitleAbout : "About"}</MenuItem>
                                    <MenuItem className={"user-profile-menu-about-item"}>
                                        <span className={"user-profile-menu-about-key"}>{labels?.aboutVersion ? labels.aboutVersion : "Version"}</span>
                                        <span className={"user-profile-menu-about-value"}>{version}</span>
                                    </MenuItem>
                                    <MenuItem className={"user-profile-menu-about-item"}>
                                        <span className={"user-profile-menu-about-key"}>{labels?.aboutEnvironment ? labels.aboutEnvironment : "Environment"}</span>
                                        <span className={"user-profile-menu-about-value"}>{environement}</span>
                                    </MenuItem>
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </div >
    );
};

export default UserProfileMenu;